import { useState } from 'react';

import { Card, Form, Button, Spinner, Alert } from 'react-bootstrap';

export const StepTestPlan = ({ busy, error, initialFreeform, initialValue, onBack, onNext }) => {

    const [testPlan, setTestPlan] = useState(initialValue || '');
    const [freeform, setFreeform] = useState(!!initialFreeform);

    const submit = e => {

        e.preventDefault();
        onNext({ freeform, testPlan: testPlan.trim() });

    };

    const canSubmit = !busy && testPlan.trim().length > 0;

    return (

        <Card>
            <Card.Body>

                <Card.Title>
                    Test plan
                </Card.Title>
                <Card.Subtitle className="text-muted mb-3">
                    Describe what you want tested in plain English.
                    {freeform
                        ? ' Freeform mode: the AI will react step-by-step against the live page, no upfront plan.'
                        : ' The AI will organize this into phases on the next step.'}
                </Card.Subtitle>

                {error && (
                <Alert variant="danger">
                    {error}
                </Alert>
                )}

                <Form onSubmit={submit}>

                    <Form.Group className="mb-3" controlId="step-plan">
                        <Form.Label>
                            Plan
                            <small className="text-muted">
                                {freeform ? '(one paragraph or bullets — keep it loose)' : '(one step or thought per line)'}
                            </small>
                        </Form.Label>
                        <Form.Control
                            placeholder={freeform
                                ? 'Sign in with the provided credentials and confirm the dashboard greets the user. Then visit Settings, verify the API key field is present, save changes, and check the confirmation toast appears.'
                                : 'Sign in with the provided credentials\nVerify the dashboard greets the user\nClick the Settings link\nVerify the API key field is visible\nSave settings and verify the confirmation appears'}
                            as="textarea"
                            disabled={busy}
                            onChange={e => setTestPlan(e.target.value)}
                            rows={8}
                            style={{ fontFamily: 'ui-monospace, monospace', fontSize: 13 }}
                            value={testPlan}
                        />
                    </Form.Group>

                    <Form.Check
                        label={(
                            <span>
                                <span className="fw-semibold">
                                    Freeform mode
                                </span>
                                <span className="text-muted small ms-2">
                                    Skip phase planning. The AI reads the goal + live page and adapts as it goes.
                                </span>
                            </span>
                        )}
                        checked={freeform}
                        className="mb-3"
                        id="step-plan-freeform"
                        onChange={e => setFreeform(e.target.checked)}
                        type="switch"
                    />

                    <div className="d-flex justify-content-between align-items-center">

                        <Button disabled={busy} onClick={onBack} variant="outline-secondary">
                            Back
                        </Button>

                        <Button disabled={!canSubmit} type="submit" variant="primary">
                            {busy
                                ? (
                                    <>
                                        <Spinner animation="border" as="span" className="me-2" size="sm" />
                                        Generating phases…
                                    </>
)
                                : (freeform ? 'Continue' : 'Generate phases')}
                        </Button>

                    </div>

                </Form>

            </Card.Body>
        </Card>

    );

};
